module.exports = __webpack_public_path__ + "img/coffret-huitres-en-ligne-boutrais-medium.1f63eb9f.png";